<app-modal
  #submitModal
  label="Submit All Answers"
  description="Are you sure you want to submit all answers? After submitting, you won't be able to review or edit your answers. Proceed?"
  (confirmed)="SubmitAll()" />

<div class="flex flex-col">
  <div class="flex justify-end mb-10 md:mb-5">
    @if(!loading()){
    <app-timer [timer]="timerConfig()" />
    }
  </div>
  <div
    class="flex min-h-0 flex-col w-full lg:p-11 p-6 bg-[#FDFDFE] rounded-xl shadow-lg">
    <div
      class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-4">
      <h1 class="text-2xl lg:text-4xl font-bold">Problems</h1>
    </div>
    <!-- Desktop Header -->
    <div
      class="hidden lg:px-8 px-5 pb-5 lg:text-2xl text-lg font-semibold lg:flex">
      <div class="w-[20%]"><p>Title</p></div>
      <div class="w-[20%]">
        <p class="text-center" id="header-difficulty">Difficulty</p>
      </div>
      <div class="w-[20%]">
        <p class="text-center" id="header-duration">Duration</p>
      </div>
      <div class="w-[20%]">
        <p class="text-center" id="header-score">Score</p>
      </div>
      <div class="w-[20%]">
        <p class="text-center" id="header-actions">Actions</p>
      </div>
    </div>

    <div class="flex-1 bg-none flex flex-col space-y-2">
      @if(!loading()){ @for(item of problemsData();track item.problemId){
      <div
        class="w-full bg-base-100 border border-gray-200 rounded-lg shadow-sm lg:px-8 px-5 py-5 flex items-center"
        id="problems-list">
        <!-- Desktop Layout -->
        <div class="hidden lg:flex items-center w-full">
          <div class="w-[20%]">
            <p
              class="font-semibold text-2xl overflow-hidden whitespace-nowrap text-ellipsis"
              id="problems-title-desktop">
              {{item.title!}}
            </p>
          </div>
          <div
            class="w-[20%] flex justify-center"
            id="problems-difficulty-desktop">
            <app-badge [value]="item.difficulty" [size]="'lg'" />
          </div>
          <div class="w-[20%]">
            <p
              class="text-center text-black text-xl"
              id="problems-duration-desktop">
              {{ item.duration }} minutes
            </p>
          </div>
          <div class="w-[20%]">
            <p
              class="text-center text-black text-xl font-semibold"
              id="problems-score-desktop">
              {{ item.score }} / 100
            </p>
          </div>
          <div class="w-[20%] flex justify-center">
            <button
              class="btn btn-primary btn-soft w-20"
              [class.loading]="getButtonState(item) === 'loading'"
              [disabled]="isButtonDisabled(item)"
              (click)="startTest(item)"
              id="problems-start-test-desktop"
            >
            {{ getButtonLabel(item) }}
            </button>
          </div>
        </div>

        <!-- Mobile Layout -->
        <div class="lg:hidden space-y-4 w-full">
          <div>
            <h3
              class="text-lg font-bold text-gray-900 mb-2"
              id="problems-title-mobile">
              {{item.title!}}
            </h3>
          </div>
          <div class="flex items-center justify-between">
            <div class="flex items-center gap-4">
              <div class="flex items-center gap-1">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M18.8997 12.2L18.1897 8.99999L18.8997 5.79999C19.0114 5.29255 18.7159 4.7841 18.2197 4.62999L15.0897 3.62999L12.6797 1.41999C12.2962 1.06427 11.7033 1.06427 11.3197 1.41999L8.90972 3.63999L5.77972 4.63999C5.28812 4.79381 4.9938 5.29589 5.09972 5.79999L5.80972 8.99999L5.09972 12.2C4.98801 12.7074 5.28352 13.2159 5.77972 13.37L7.99972 14.07V21C8.00161 21.3668 8.20423 21.7032 8.52764 21.8764C8.85105 22.0496 9.24333 22.0318 9.54972 21.83L11.9997 20.2L14.4497 21.83C14.7561 22.0318 15.1484 22.0496 15.4718 21.8764C15.7952 21.7032 15.9978 21.3668 15.9997 21V14.07L18.2197 13.37C18.7159 13.2159 19.0114 12.7074 18.8997 12.2ZM11.4497 18.2L9.99972 19.2V15.36L11.3197 16.58C11.5057 16.749 11.7484 16.8418 11.9997 16.84C12.2501 16.8372 12.4913 16.745 12.6797 16.58L13.9997 15.36V19.13L12.5497 18.2C12.216 17.9802 11.7835 17.9802 11.4497 18.2ZM13.8997 12.76C14.0105 12.6621 14.1397 12.5873 14.2797 12.54L16.7497 11.74L16.1797 9.21999C16.1498 9.07484 16.1498 8.92513 16.1797 8.77999L16.7497 6.25999L14.2797 5.48999C14.1397 5.44269 14.0105 5.36789 13.8997 5.26999L11.9997 3.51999L10.0997 5.26999C9.98897 5.36789 9.85977 5.44269 9.71972 5.48999L7.24972 6.25999L7.81972 8.77999C7.84963 8.92513 7.84963 9.07484 7.81972 9.21999L7.24972 11.74L9.71972 12.51C9.85977 12.5573 9.98897 12.6321 10.0997 12.73L11.9997 14.48L13.8997 12.76Z"
                    fill="#231F20" />
                </svg>
                <app-badge [value]="item.difficulty" />
              </div>
              <div class="flex items-center gap-1">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 9.34784 20.9464 6.8043 19.0711 4.92893C17.1957 3.05357 14.6522 2 12 2ZM12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 14.1217 19.1571 16.1566 17.6569 17.6569C16.1566 19.1571 14.1217 20 12 20ZM15 14C15.4482 14.0234 15.857 13.7454 16 13.32C16.0836 13.0614 16.0583 12.78 15.9301 12.5404C15.8018 12.3008 15.5815 12.1238 15.32 12.05L13 11.28V7C13 6.44772 12.5523 6 12 6C11.4477 6 11 6.44772 11 7V12C10.9989 12.4299 11.2727 12.8124 11.68 12.95L14.68 13.95C14.784 13.9805 14.8916 13.9973 15 14Z"
                    fill="#231F20" />
                </svg>
                <span class="text-sm font-medium" id="problems-duration-mobile"
                  >{{item.duration}} mins</span
                >
              </div>
            </div>
          </div>
          <div class="flex items-center justify-between pt-2">
            <div
              class="text-sm font-semibold text-gray-700"
              id="problems-score-mobile">
              Score: {{ item.score }} / 100
            </div>
            <div class="w-20">
              <button
                class="btn btn-primary btn-soft w-20"
                [class.loading]="getButtonState(item) === 'loading'"
                [disabled]="isButtonDisabled(item)"
                (click)="startTest(item)"
                id="problems-start-test-mobile"
              >
              {{ getButtonLabel(item) }}
              </button>
            </div>
          </div>
        </div>
      </div>
      } } @else {
      <div class="flex items-center justify-center h-full">
        <p class="text-gray-400 text-4xl md:text-2xl">Loading . . .</p>
      </div>
      }
    </div>
    <div class="flex flex-row pt-7 justify-end">
      <app-button
        color="primary"
        label="Submit All"
        [loading]="submitting() || loading()"
        [disabled]="submitting() || loading()"
        (clicked)="handleSubmitAll()" />
    </div>
  </div>
</div>
